import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import './checkoutContactInfo.scss';
import { InputText } from 'primereact/inputtext';

import { Checkbox } from 'primereact/checkbox';
import CustomInput from './CustomInput';

import CardPeacock from './PeacockCheckoutCard';
import CardCheckout from './CheckoutCard';

import CustomDropDown from './CustomDropDown';
import fetchStatesDropdownOptions from '../services/states';
import getDemoLink from '../utils/helpers';

function CheckoutContactInfo({
  selectedCard,
  updateForm,
  values,
  devicePrice,
  devicePriceFee,
  shippingPriceFee,
  formErrors,
  renderButtons,
  setForm,
  showFireCode = false,
}) {
  const handleChange = e => {
    updateForm(e);
  };
  const Card = showFireCode ? CardPeacock : CardCheckout;
  const [initialValues] = useState(values);
  const [USStatesDropdownOptions, setUSStatesDropdownOptions] = useState([]);

  useEffect(async () => {
    const options = await fetchStatesDropdownOptions();
    setUSStatesDropdownOptions(options);
  }, []);

  return (
    <div id="checkoutContactInfo">
      <div className="card-container">
        <div className="grid main_container">
          <div className="data_container col-7">
            <div className="grid">
              <div className="col-12 flex align-items-center header">
                <div className="header_number">2</div>
                <div className="header_text_box">
                  <p className="step_text_mobile">Step 2 of 4</p>
                  <h2 className="header_title">Contact Information</h2>
                </div>
              </div>
              <div className="form_conatiner">
                <div className="col-12 sub-header padding_0">
                  <h3>Login Information</h3>
                </div>
                <div className="inputs_box flex margin_input">
                  <div className="col-6">
                    <div className="field title-input">
                      <span className="block label required_icon" htmlFor="email">
                        Email
                      </span>
                      <CustomInput
                        error={formErrors.businessEmail}
                        errorMessage={formErrors.businessEmail}
                        value={values.businessEmail || ''}
                        onChange={handleChange}
                        name="businessEmail"
                        type="text"
                        placeholder="example@example.com"
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="field title-input">
                      <span className="block label required_icon" htmlFor="confirmEmail">
                        Confirm Email
                      </span>
                      <CustomInput
                        error={formErrors.businessEmailConfirmation}
                        errorMessage={formErrors.businessEmailConfirmation}
                        value={values.businessEmailConfirmation || ''}
                        onChange={handleChange}
                        name="businessEmailConfirmation"
                        type="text"
                        placeholder="example@example.com"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 paraf padding_0">
                  <p>
                    <b>Note: </b>Upon device shipment, you will be sent an email to create your password
                  </p>
                </div>

                <div className="col-12 sub-header padding_0">
                  <h3>Additional Information</h3>
                </div>

                <div className="inputs_box flex margin_input">
                  <div className="col-6">
                    <div className="field title-input">
                      <span className="block label required_icon" htmlFor="name">
                        Name
                      </span>
                      <CustomInput
                        error={formErrors.firstName}
                        errorMessage={formErrors.firstName}
                        value={values.firstName || ''}
                        onChange={handleChange}
                        name="firstName"
                        type="text"
                        placeholder="First Name..."
                      />
                    </div>
                  </div>
                  <div className="col-6 ">
                    <div className="field title-input">
                      <span className="block label required_icon" htmlFor="lastName">
                        Last name
                      </span>
                      <CustomInput
                        error={formErrors.lastName}
                        errorMessage={formErrors.lastName}
                        value={values.lastName || ''}
                        onChange={handleChange}
                        name="lastName"
                        type="text"
                        placeholder="Last Name..."
                      />
                    </div>
                  </div>
                </div>
                <div className="inputs_box flex margin_input">
                  <div className="col-6">
                    <div className="field title-input">
                      <span className="block label" htmlFor="role">
                        Role at business
                      </span>
                      <InputText
                        value={values.role || ''}
                        onChange={handleChange}
                        name="role"
                        type="text"
                        placeholder="Role..."
                      />
                    </div>
                  </div>
                </div>
                <div className="inputs_box flex margin_input">
                  <div className="col-6">
                    <div className="field title-input">
                      <span className="block label required_icon" htmlFor="phone">
                        Phone number
                      </span>
                      <CustomInput
                        error={formErrors.phone}
                        errorMessage={formErrors.phone}
                        value={values.phone || ''}
                        onChange={handleChange}
                        name="phone"
                        type="text"
                        placeholder="Phone Number..."
                      />
                    </div>
                  </div>
                </div>
                <div className=" col-12 sub-header padding_0">
                  <h3>Shipping Address</h3>
                </div>
                <div className="col-12 field-radiobutton padding_0">
                  <Checkbox
                    inputId="useBusinessAddressForShipping"
                    name="useBusinessAddressForShipping"
                    checked={values.useBusinessAddressForShipping}
                    onChange={e => {
                      if (e.checked) {
                        setForm({
                          ...values,
                          shippingCity: initialValues.city,
                          shippingBusinessAddress: initialValues.businessAddress,
                          shippingBusinessAddress2: initialValues.businessAddress2,
                          shippingZipCode: initialValues.zipCode,
                          shippingState: initialValues.state,
                          shippingCountry: initialValues.country,
                          useBusinessAddressForShipping: true,
                        });
                      } else {
                        setForm({
                          ...values,
                          shippingCity: '',
                          shippingBusinessAddress: '',
                          shippingBusinessAddress2: '',
                          shippingZipCode: '',
                          shippingState: '',
                          shippingCountry: 'United States',
                          useBusinessAddressForShipping: false,
                        });
                      }
                    }}
                  />
                  <span>
                    <label htmlFor="binary">Same as business address</label>
                  </span>
                </div>
                <div className="grid">
                  <div className="atn_input col-6">
                    <div className="field title-input">
                      <span className="block label required_icon" htmlFor="atn">
                        ATTN
                      </span>
                      <CustomInput
                        error={formErrors.shippingATTN}
                        errorMessage={formErrors.shippingATTN}
                        value={values.shippingATTN || ''}
                        onChange={handleChange}
                        name="shippingATTN"
                        type="text"
                        placeholder="ATTN..."
                      />
                    </div>
                  </div>
                  <div className="col-12 flex inputs_box padding_0">
                    <div className="col-6">
                      <div className="field title-input">
                        <span className="block label required_icon" htmlFor="shippingBusinessAddress">
                          Address Line 1
                        </span>
                        <CustomInput
                          error={formErrors.shippingBusinessAddress}
                          errorMessage={formErrors.shippingBusinessAddress}
                          value={values.shippingBusinessAddress || ''}
                          onChange={handleChange}
                          name="shippingBusinessAddress"
                          type="text"
                          placeholder="Street Address..."
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="field title-input">
                        <span className="block label" htmlFor="shippingBusinessAddress2">
                          Address Line 2
                        </span>
                        <CustomInput
                          error={formErrors.shippingBusinessAddress2}
                          errorMessage={formErrors.shippingBusinessAddress2}
                          value={values.shippingBusinessAddress2 || ''}
                          onChange={handleChange}
                          name="shippingBusinessAddress2"
                          type="text"
                          placeholder="Street Address..."
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex inputs_box col-12 padding_0">
                    <div className="flex left_box col-6 padding_0">
                      <div className="col-6">
                        <div className="p-field title-input">
                          <span className="block label required_icon" htmlFor="shippingCity">
                            City
                          </span>
                          <CustomInput
                            error={formErrors.shippingCity}
                            errorMessage={formErrors.shippingCity}
                            value={values.shippingCity}
                            onChange={handleChange}
                            name="shippingCity"
                            placeholder="City..."
                          />
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="field title-input">
                          <span className="block label required_icon" htmlFor="shippingZipCode">
                            Zip code
                          </span>
                          <CustomInput
                            error={formErrors.shippingZipCode}
                            errorMessage={formErrors.shippingZipCode}
                            value={values.shippingZipCode || ''}
                            onChange={handleChange}
                            name="shippingZipCode"
                            type="text"
                            placeholder="Zip Code..."
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="field title-input">
                        <span className="block label required_icon" htmlFor="shippingState">
                          State / Province
                        </span>
                        <CustomDropDown
                          error={formErrors.shippingState}
                          errorMessage={formErrors.shippingState}
                          value={values.shippingState}
                          options={USStatesDropdownOptions}
                          onChange={handleChange}
                          placeholder={USStatesDropdownOptions.length === 0 ? 'Loading' : 'State / Province...'}
                          name="shippingState"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="country_input col-12">
                    <div className="field title-input">
                      <span className="block label" htmlFor="shippingCountry">
                        Country
                      </span>
                      <CustomInput
                        error={formErrors.shippingCountry}
                        errorMessage={formErrors.shippingCountry}
                        value={values.shippingCountry}
                        onChange={handleChange}
                        name="shippingCountry"
                        placeholder="Country..."
                        disabled
                      />
                    </div>
                    <div className="col-12 paraf padding_0">
                      <p>
                        <b>Note: </b>If you live outside of the United States, please contact our&nbsp;
                        <a href={getDemoLink(showFireCode)} target="_blank" rel="noopener noreferrer">
                          Customer Success
                        </a>
                        &nbsp;team so we can get you set up
                      </p>
                    </div>
                  </div>
                </div>
                {renderButtons()}
              </div>
            </div>
          </div>
          <div className="card_container col-5 justify-content-center align-self-start">
            <Card
              id={selectedCard?.id}
              title={selectedCard?.title}
              price={selectedCard?.priceText}
              checkList={selectedCard?.checklistP}
              icon={selectedCard?.icon}
              devicePrice={devicePrice}
              numberOfDevices={values.numberOfDevices}
              devicePriceFee={devicePriceFee}
              shippingPriceFee={shippingPriceFee}
              showFireCode
              peacockFee={values.fireCodePrice}
              billingPlan={values.billingPlan}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

CheckoutContactInfo.propTypes = {
  values: PropTypes.shape({
    businessEmail: PropTypes.string.isRequired,
    businessEmailConfirmation: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    shippingATTN: PropTypes.string.isRequired,
    socialMedia: PropTypes.string.isRequired,
    businessAddress: PropTypes.string.isRequired,
    businessAddress2: PropTypes.string,
    shippingBusinessAddress: PropTypes.string,
    shippingBusinessAddress2: PropTypes.string,
    shippingCity: PropTypes.string,
    shippingZipCode: PropTypes.string,
    shippingState: PropTypes.string,
    shippingCountry: PropTypes.string,
    useBusinessAddressForShipping: PropTypes.string,
    numberOfDevices: PropTypes.number.isRequired,
    zipCode: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    socialByUpShow: PropTypes.bool.isRequired,
    socialHandle: PropTypes.bool.isRequired,
    noSocial: PropTypes.bool.isRequired,
    mediaAccount: PropTypes.string.isRequired,
    fireCodePrice: PropTypes.number,
    billingPlan: PropTypes.string,
    source: PropTypes.string,
  }).isRequired,
  devicePrice: PropTypes.number,
  devicePriceFee: PropTypes.number,
  shippingPriceFee: PropTypes.number,
  updateForm: PropTypes.func.isRequired,
  selectedCard: PropTypes.objectOf(PropTypes.any),
  formErrors: PropTypes.objectOf(PropTypes.any),
  renderButtons: PropTypes.any,
  showFireCode: PropTypes.bool,
  setForm: PropTypes.func.isRequired,
};

CheckoutContactInfo.defaultProps = {
  devicePrice: undefined,
  devicePriceFee: undefined,
  shippingPriceFee: undefined,
  formErrors: undefined,
  selectedCard: undefined,
  renderButtons: () => {},
  showFireCode: false,
};

export default CheckoutContactInfo;
